import { defineStore } from 'pinia';
import { getUserInfo } from '../api/control/info';

export const useModal = defineStore({
  id: 'useModal',
  state: () => ({ 
    showModal: false,
    userInfo: sessionStorage.getItem('userInfo') ? JSON.parse(sessionStorage.getItem('userInfo')) : {},
    jumpFlag: 1, // 1是登录之后还在当前页面，2是登录之后跳转到控制台, 3跳转能力中心
    showAuthModal: false,
    tenant: sessionStorage.getItem('tenantId') || '',
    userDetail: {},
  }),
  getters: {
    modalVal: state => state.showModal,
    userInfoData: state => state.userInfo,
    userJumpFlag: state => state.jumpFlag,
    authModal: state => state.showAuthModal,
    tenantId: state => state.tenant,
    userDetailData: state => state.userDetail
  },
  actions: {
    changeModal(flag) {
      this.showModal = flag
    },
    changeUserInfo(userInfo) {
      sessionStorage.setItem('userInfo', JSON.stringify(userInfo));
      this.userInfo = userInfo;
    },
    changeJumpFlag(type) {
      this.jumpFlag = type;
    },
    changeAuthModal(flag) {
      this.showAuthModal = flag
    },
    async getUserInfo(userInfo) {
      try {
        const res = await getUserInfo({
          userId: userInfo?.user_id
        });
        this.tenant = res.data?.tenantId;
        sessionStorage.setItem('tenantId', this.tenant);
      } catch (err) {
        console.log(err);
      }
    },
    getUserDetail(detail) {
      console.log(detail, 'detail');
      
      this.userDetail = detail;
    }
  }
})